export type SearchStats = {
    searchTerm: string;
    searchResults?: number | undefined;
    searchType?: string;
    isSuggestedProduct?: boolean;
};

export const storageSearchedTermKey = 'psLastSearchedTerm';

export const storageSearchStats = 'psLastSearchStats';

// These are kept because they are maintained on Legacy as well.
// sessionStorage is used intentionally so that the search term is cleared when the browser session ends.
const getSearchedTerm = (): string => {
    const searchTerms = sessionStorage.getItem(storageSearchedTermKey);
    return searchTerms ? JSON.parse(searchTerms) : '';
};

const setSearchedTerm = (searchTerm?: string): void => {
    sessionStorage.setItem(storageSearchedTermKey, JSON.stringify(searchTerm));
};

export const getSearchStats = (): SearchStats => {
    const storageStats = sessionStorage.getItem(storageSearchStats);
    const searchStats = storageStats
        ? JSON.parse(storageStats)
        : {
              searchType: '',
              searchResults: undefined,
          };

    return {
        ...searchStats,
        searchTerm: getSearchedTerm(),
    };
};

export const setSearchStats = ({ searchResults, searchTerm, searchType, isSuggestedProduct }: SearchStats) => {
    setSearchedTerm(searchTerm);

    sessionStorage.setItem(
        storageSearchStats,
        JSON.stringify({
            searchResults,
            searchTerm,
            searchType,
            isSuggestedProduct,
        })
    );
};
